import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import FuseTheme from '../global/theme';

const JobInputTitleStyles = {
    divider: {
        display: 'block',
        width: '100%',
        height: 1,
        backgroundColor: FuseTheme.palette.primary1Color,
        border: 'none',
        margin: '1em 0 0.5em 0'
    },
    title: {margin: '16px 0 4px 0'},
    p: {lineHeight: 1.3, margin: '0 0 10px 0'}
}

class JobInputTitle extends Component {
    render() {
        const {
            label,
            tooltip
        } = this.props;

        return (
            <Fragment>
                <hr style={JobInputTitleStyles.divider}/>
                <h3 style={JobInputTitleStyles.title}>{label}</h3>
                {tooltip &&
                    <p style={JobInputTitleStyles.p}>{tooltip}</p>
                }
            </Fragment>
        )
    }
}

JobInputTitle.propTypes = {
    label: PropTypes.string,
    tooltip: PropTypes.string
};

export default JobInputTitle;



// WEBPACK FOOTER //
// ./src/Fuse/components/JobInputTitle.js